function addZeroToNumber(number: number): string {
  let numberWithZero;

  if (number < 10) {
    numberWithZero = '0' + number;
  } else {
    numberWithZero = number;
  }

  return String(numberWithZero);
}

export default addZeroToNumber;
